import * as XLSX from 'xlsx';

function autoWidthCount(ws, data) {
  /* set worksheet max width per col*/
  const colWidth = data.map((row) =>
    row.map((val) => {
      /* if null/undefined*/
      if (val == null) {
        return { wch: 10 };
      } else if (val.toString().charCodeAt(0) > 255) {
        /* if chinese*/
        return { wch: val.toString().length * 2 };
      } else {
        return { wch: val.toString().length };
      }
    })
  );
  /* start in the first row*/
  let result = colWidth[0];
  for (let i = 1; i < colWidth.length; i++) {
    for (let j = 0; j < colWidth[i].length; j++) {
      if (result[j]['wch'] < colWidth[i][j]['wch']) {
        result[j]['wch'] = colWidth[i][j]['wch'];
      }
    }
  }
  ws['!cols'] = result;
}

function json_to_array(key, jsonData) {
  return jsonData.map((v) =>
    key.map((j) => {
      return v[j];
    })
  );
}

// header Object，表頭
// data Array，表體數據
// key Array，字段名
// title String，標題（會居中顯示），即excel表格第一行
// filename String，文件名
// autoWidth Boolean，是否自動根據key自定義列寬度

export const exportExcel = ({ header, data, key, title, filename, autoWidth }) => {
  const wb = XLSX.utils.book_new();
  if (header) {
    data.unshift(header);
  }
  if (title) {
    data.unshift(title);
  }
  const ws = XLSX.utils.json_to_sheet(data, {
    header: key,
    skipHeader: true
  });
  if (autoWidth) {
    const arr = json_to_array(key, data);
    autoWidthCount(ws, arr);
  }
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename + '.xlsx');
};
